/* eslint-disable */
require('./counterintelligence_open')
require('./defense_global_dome')
require('./defense_local_dome')
require('./defense_local_open')
require('./defense_local_orbital')
require('./factory_open')
require('./factory_orbital')
require('./finance_open')
require('./finance_orbital')
require('./frame_dome_hidden')
require('./frame_dome')
require('./frame_open_hidden')
require('./frame_open')
require('./frame_orbital_hidden')
require('./frame_orbital')
require('./hab_dome')
require('./hab_open_poor')
require('./hab_open_rich')
require('./hab_open')
require('./happy_open')
require('./happy_orbital')
require('./happy_pot_dome')
require('./happy_pot_open')
require('./happy_pot_orbital')
require('./high_factory_dome')
require('./hypergate')
require('./ideo_credit_open')
require('./ideo_dome')
require('./ideo_open')
require('./infra_dome')
require('./infra_open')
require('./lift_dome')
require('./lift_open')
require('./market_dome')
require('./market_open')
require('./military_school_dome')
require('./mine_dome')
require('./mine_orbital')
require('./monument_dome')
require('./monument_open')
require('./radar_orbital')
require('./removecontact_dome')
require('./removecontact_open')
require('./research_dome')
require('./research_open')
require('./research_orbital')
require('./shipyard_1_orbital')
require('./shipyard_2_orbital')
require('./shipyard_3_orbital')
require('./shipyard_4_orbital')
require('./spatioport_dome')
require('./spatioport_open')
require('./spatioport_orbital')
require('./university_open')
